import React, { useEffect, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { Spin, PageHeader, Space } from "antd";
import queryString from "query-string";
import { MoreOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";

import { Table } from "../../components";
import { Container, TableContainer } from "./styles";
import { columns } from "./helpers";
import { helpers } from "../../utils";
import { getUrl, requests } from "../../globals/requests";
import { Pagination } from "../../components";
import { useUrl } from "../../hooks";

const buffData = {};
const buffTotal = {};

function Savings(props) {
  const [savings, setSavings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(null);
  const [page, setPage] = useState(1);
  const limit = 10;

  const location = useLocation();
  const history = useHistory();
  //useUrl(location, history, { page: 1, limit: 1 });

  function moreOptions(saving) {
    history.push(`/dashboard/savings/${saving?._id}`);
  }

  columns[columns.length - 1].render = (saving) => (
    <MoreOutlined
      style={{ fontSize: "20px" }}
      onClick={() => moreOptions(saving)}
    />
  );

  function onPaginationChange(current, limit) {
    setPage(current);
    getSavings({ page: current, limit });
  }

  const getSavings = useCallback(async (params) => {
    try {
      const queryObj = queryString.parse(window.location.search);
      const query = { ...queryObj, ...params };
      const key = JSON.stringify(query);

      if (buffTotal[key] && buffData[key]) {
        setSavings(buffData[key]);
        setTotalPages(buffTotal[key]);
      }
      const url = getUrl("savings");
      //setLoading(true);
      const response = await requests.getWithAuth(url, query);
      const { data, total } = response.data;
      setSavings(data);
      if (!buffData[key]) {
        buffData[key] = data;
      }
      if (!buffTotal[key]) {
        buffTotal[key] = total;
      }
      setLoading(false);
      setTotalPages(total);
    } catch (e) {
      console.log(e);
      helpers.displayMessage(e);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getSavings({ page, limit });
  }, [getSavings, page]);

  if (loading) {
    return (
      <div className="spin-contain">
        <Spin delay={100} size="large" tip="Getting Savings..."></Spin>
      </div>
    );
  }
  return (
    <Container>
      <PageHeader
        className="site-page-header"
        onBack={() => history.goBack()}
        title="Savings"
      />
      <Space direction="vertical" size="large">
        <TableContainer>
          <Table pagination={false} columns={columns} dataSource={savings} />
        </TableContainer>
        {!!totalPages && (
          <Pagination
            position="left"
            current={page}
            limit={limit}
            total={totalPages}
            showSizeChanger
            onChange={onPaginationChange}
          />
        )}
      </Space>
    </Container>
  );
}

export default Savings;
